import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import {
  fetchFiltersWithNotification,
  clearFilters,
} from '@store/slices/filtersSlice';

export const FiltersInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingFilters = useAppSelector((state) => state.filters.isLoading);
  const hasFetched = useAppSelector((state) => state.filters.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear filters when user logs out
    if (!username) {
      dispatch(clearFilters());
      return;
    }

    // Fetch filters when user is available and we haven't fetched yet
    if (!hasFetched && !isLoadingFilters) {
      dispatch(fetchFiltersWithNotification(username));
    }
  }, [user?.username, hasFetched, isLoadingFilters, dispatch]);

  return null;
};
